<div class="ui raised segment margin-bottom-10">
    <div class="ui grid">
        <div class="two wide column">
            <img src="{{van.leasing.picture}}" class="image">
        </div>
        <div class="ten wide column van-data">
            <h3>{{van.leasing.name}}</h3>
            <p>{{van.calendar.reservations.length + " employees.html"}}</p>
            <p>{{van.plate}}</p>
        </div>
        <div class="four wide column">
            <button *ngIf="!van.enabled" class="ui positive button van-button" (click)="enabled.emit()">Activer</button>
            <button *ngIf="!van.enabled" class="ui negative button van-button" (click)="removed.emit()">Supprimer</button>
            <button *ngIf="van.enabled" class="ui warning button van-button" (click)="disabled.emit()">Désactiver</button>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/leasing/presentation/vanEditComponent/vanDetails/vanDetails.html